import styled from "styled-components";
import { Radio } from "@material-ui/core";
import theme from "~/styles/theme";

export const StyledRadio = styled(Radio)`
  font-size: 18px;
  display: inline-block;
  position: relative;
  padding: 0;
  margin-right: 8px;
  margin-top: 0;
  max-height: 18px;

  &.Mui-checked {
    background-color: ${theme.palette.neutral.primary.key} !important;
    position: relative;

    svg {
      padding: 2px;
    }
  }

  span {
    width: 18px;
    height: 18px;
    position: relative;
  }
`;
